import { KeyValue } from "@almamedia/amr-adtech-stack/lib/services/ads";
import { StackContext } from "../context";

type AdTargetingParam = {
  getValue: (
    // eslint-disable-next-line no-unused-vars
    context: StackContext
  ) => KeyValue;
};

const targeting: AdTargetingParam[] = [
  {
    getValue: (context: StackContext) => {
      const dl = context.services.dataLayerService?.dataLayer;
      return { key: "primaryCategory", value: [dl?.primaryCategory ?? ""] };
    },
  },
  {
    getValue: (context: StackContext) => {
      const dl = context.services.dataLayerService?.dataLayer;
      return { key: "subCategory", value: [dl?.subCategory ?? ""] };
    },
  },
  {
    getValue: (context: StackContext) => {
      const dl = context.services.dataLayerService?.dataLayer;
      return { key: "subCategory1", value: [dl?.subCategory1 ?? ""] };
    },
  },
  {
    getValue: (context: StackContext) => {
      const dl = context.services.dataLayerService?.dataLayer;
      return { key: "subCategory2", value: [dl?.subCategory2 ?? ""] };
    },
  },
  {
    getValue: (context: StackContext) => {
      const dl = context.services.dataLayerService?.dataLayer;
      return { key: "primaryCategory", value: [dl?.primaryCategory ?? ""] };
    },
  },
  {
    getValue: (context: StackContext) => {
      const dl = context.services.dataLayerService?.dataLayer;
      return { key: "pageClass", value: [dl?.pageClass ?? ""] };
    },
  },
  {
    getValue: (context: StackContext) => {
      const dl = context.services.dataLayerService?.dataLayer;
      return { key: "tags", value: dl?.pageTags ?? [] };
    },
  },
  {
    getValue: (context: StackContext) => {
      const dl = context.services.dataLayerService?.dataLayer;
      return { key: "URL", value: [dl?.locationHref ?? ""] };
    },
  },
  {
    getValue: (context: StackContext) => {
      const dl = context.services.dataLayerService?.dataLayer;
      return { key: "pageId", value: [dl?.pageId ?? ""] };
    },
  },
  {
    getValue: (context: StackContext) => {
      const dl = context.services.dataLayerService?.dataLayer;
      return { key: "userAgent", value: [dl?.userAgent ?? ""] };
    },
  },
  {
    getValue: (context: StackContext) => {
      const dl = context.services.dataLayerService?.dataLayer;
      return { key: "FB", value: [dl?.fb ?? ""] };
    },
  },
  {
    getValue: (context: StackContext) => {
      const dl = context.services.dataLayerService?.dataLayer;
      return {
        key: "airTemperature",
        value: [dl?.airTemperature?.toString(10) ?? ""],
      };
    },
  },
  {
    getValue: (context: StackContext) => {
      const dl = context.services.dataLayerService?.dataLayer;
      return {
        key: "precipitation",
        value: [dl?.precipitation?.toString(10) ?? ""],
      };
    },
  },
];

export default targeting;
